import { render, staticRenderFns } from "./CopilotInsights.vue?vue&type=template&id=0db037d9&"
import script from "./CopilotInsights.vue?vue&type=script&lang=js&"
export * from "./CopilotInsights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports